// DS: CR01F
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommissionViewer from '../../../DaEditorWrapper/Viewer/Commission';
import TextRenderer from '../../../TextRenderer';
import { DeviationLink } from '../../../Duperbrowse';
import OrderCommissionButton from '../../../ActionBar/buttons/OrderCommissionButton';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import { DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH, DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT } from '../constants';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../feedcard.legacy.theme.scss';
import expandableWrapperStyles from '../_partials/ExpandableWrapper/ExpandableWrapper.scss';
import s from './Commission.scss';
// commission is especially tall because of it's special cover image
const COLLAPSED_CONTENT_HEIGHT = 480;
const COVER_DOM_HEIGHT_DESKTOP = 280;
const COVER_DOM_HEIGHT_MOBILE = 295;
const CommissionFeedCardContents = ({ className, deviation, extraActions, withWatchOrSubscribeButton })=>{
    var _deviation_commission, _deviation_commission1;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const coverImage = getCoverImageAttributes({
        deviation,
        width: DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH,
        height: DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT,
        allowHuge: true
    });
    const coverImageDomHeight = isMobile ? COVER_DOM_HEIGHT_MOBILE : COVER_DOM_HEIGHT_DESKTOP;
    // maintain this so we can track when we can enable scroll restoration on duperbrowse
    const [isLayoutReady, setIsLayoutReady] = useState(false);
    const onLayoutReady = useCallback(()=>{
        setIsLayoutReady(true);
    }, []);
    return /*#__PURE__*/ React.createElement(FeedCardLayout, {
        className: className,
        deviation: deviation,
        extraActions: extraActions,
        isExpandable: true,
        withCommentControl: false,
        withWatchOrSubscribeButton: withWatchOrSubscribeButton,
        collapsedContentHeight: COLLAPSED_CONTENT_HEIGHT,
        // special order button for special commission special case
        additionalActionbarActions: /*#__PURE__*/ React.createElement("div", {
            className: s['order-info']
        }, /*#__PURE__*/ React.createElement("span", {
            className: s['price']
        }, "$", (_deviation_commission = deviation.commission) === null || _deviation_commission === void 0 ? void 0 : _deviation_commission.dollarsCost), /*#__PURE__*/ React.createElement(OrderCommissionButton, {
            deviation: deviation
        })),
        // special mobile expansion button to navigate to special commission on mobile :|
        expansionButton: isMobile ? /*#__PURE__*/ React.createElement(DeviationLink, {
            className: classnames(s['toggle-button'], expandableWrapperStyles['toggle-button']),
            deviation: deviation,
            disableScrollRestoration: !isLayoutReady
        }, /*#__PURE__*/ React.createElement("span", {
            className: expandableWrapperStyles['toggle-button-contents']
        }, t('deviationview.feed.readmore'))) : null,
        onLayoutReady: onLayoutReady
    }, coverImage && /*#__PURE__*/ React.createElement("div", {
        className: s['cover-image'],
        style: {
            height: coverImageDomHeight
        }
    }, /*#__PURE__*/ React.createElement("div", _object_spread({
        className: s['blurred-bg-image']
    }, coverImage)), /*#__PURE__*/ React.createElement("div", {
        className: s['fade']
    }), /*#__PURE__*/ React.createElement("div", _object_spread({
        className: s['foreground-image']
    }, coverImage))), /*#__PURE__*/ React.createElement("div", {
        className: s['title-and-price']
    }, /*#__PURE__*/ React.createElement(FeedCardTitle, {
        className: s['title'],
        deviation: deviation,
        disableScrollRestoration: !isLayoutReady
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, "$", (_deviation_commission1 = deviation.commission) === null || _deviation_commission1 === void 0 ? void 0 : _deviation_commission1.dollarsCost)), deviation.textContent.excerpt.trim().length > 0 && /*#__PURE__*/ React.createElement(TextRenderer, {
        textContent: deviation.textContent,
        reactViewer: CommissionViewer,
        viewerKey: deviation.deviationId,
        legacyTheme: "commission",
        fixedParagraph: false,
        disableLazyLoading: true,
        draftjsThemeOverride: draftTheme,
        className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override'], draftTheme['commission'])
    }));
};
CommissionFeedCardContents.displayName = 'CommissionFeedCardContents';
export default CommissionFeedCardContents;

//# sourceMappingURL=Commission.js.map